import { render, staticRenderFns } from "./RelatedInfoDataTable.vue?vue&type=template&id=d4f1ec0e&"
import script from "./RelatedInfoDataTable.vue?vue&type=script&lang=js&"
export * from "./RelatedInfoDataTable.vue?vue&type=script&lang=js&"
import style0 from "./RelatedInfoDataTable.vue?vue&type=style&index=0&id=d4f1ec0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports